import clsx from "clsx";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Banner from "components/banner/Banner";
import Loader from "components/Loader/Loader";
import NormalText from "components/Typography/NormalText";
import { FETCH_STATE } from "constants/fetchState";
import { OpekepeSyncStepStyled } from "./OpekepeSyncStepStyled";

const OpekepeSyncStep = ({
  index,
  title,
  isDisabled,
  state,
  loadingText,
  errorText,
  successText,
  content = [],
}) => {
  const { t } = useTranslation();

  return (
    <OpekepeSyncStepStyled
      className={clsx({
        disabled: isDisabled,
      })}
    >
      <div className="step-title">
        <span className="step-index">
          <NormalText>{index}</NormalText>
        </span>
        <NormalText>{title}</NormalText>
      </div>
      <div className="step-content">
        {state.state === FETCH_STATE.LOADING && (
          <div className="step-loading">
            <Loader className="loader" />
            <NormalText>{loadingText}</NormalText>
          </div>
        )}
        {state.state === FETCH_STATE.ERROR && (
          <>
            <Banner.Error text={errorText} />
            <div className="content-row">
              <NormalText>{t("OpekepeSync.DateTime")}</NormalText>
              <NormalText>{moment()?.format("MMMM Do YYYY, h:mm")}</NormalText>
            </div>
          </>
        )}
        {state.state === FETCH_STATE.SUCCESS && (
          <>
            <Banner.Success text={successText} />
            <div className="content-row">
              <NormalText>{t("OpekepeSync.DateTime")}</NormalText>
              <NormalText>
                {moment(state.data.dateSynced)?.format("MMMM Do YYYY, h:mm")}
              </NormalText>
            </div>
            {content.map(({ key, title }) => (
              <div className="content-row">
                <NormalText>{title}</NormalText>
                <NormalText>{state.data?.[key]}</NormalText>
              </div>
            ))}
          </>
        )}
      </div>
    </OpekepeSyncStepStyled>
  );
};

export default OpekepeSyncStep;
